import { Dispatch } from 'react';
import { UserContextAction } from '../components/app/user-context';
import {
  LoginDocument,
  LoginMutation,
  LoginMutationVariables,
  LogoutDocument,
  LogoutMutation,
  LogoutMutationVariables,
  OktaTokenExchangeDocument,
  OktaTokenExchangeMutation,
  OktaTokenExchangeMutationVariables,
} from '../generated/graphql';
import { ILoginService } from '../rs-emd-ui-modules/src/services/profile/login/login-service';
import {
  ILoginRequest,
  ILoginResponse,
  IOktaTokenExchangeRequest,
  IOktaTokenExchangeResponse,
} from '../rs-emd-ui-modules/src/services/profile/login/login.dto';
import { pushEvent } from '../tagging/ensighten';
import { pushGA4Event } from '../tagging/ga4';
import { graphQLService } from './graphql-service';
import { headerService } from './header-service';

export class LoginService implements ILoginService {
  pushEvent(): void {
    return pushEvent('loginOrContinueAsGuestEvent', undefined);
  }

  async login(req: ILoginRequest, callback: Dispatch<UserContextAction> | null): Promise<ILoginResponse> {
    const result = await graphQLService.apolloClient.mutate<LoginMutation, LoginMutationVariables>({
      mutation: LoginDocument,
      variables: { data: req },
    });

    let res: ILoginResponse = {};

    if (result.data) {
      res.data = result.data.login;

      if (res.data.isSuccess) {
        //update header totals
        headerService.getHeaderTotals(callback);

        pushEvent('login.successful', '');

        result.data.login.tags.forEach((t) => {
          if (t.__typename === 'GA4Event_User_Login') {
            pushGA4Event(t);
          }
        });
      } else {
        pushEvent('login.error', 'bad_credentials');
      }
    }

    return res;
  }

  async oktaTokenExchange(
    req: IOktaTokenExchangeRequest,
    callback: Dispatch<UserContextAction> | null
  ): Promise<IOktaTokenExchangeResponse> {
    const result = await graphQLService.apolloClient.mutate<OktaTokenExchangeMutation, OktaTokenExchangeMutationVariables>({
      mutation: OktaTokenExchangeDocument,
      variables: { data: req },
    });

    let res: IOktaTokenExchangeResponse = {};

    if (result.data) {
      res.data = result.data.oktaTokenExchange;

      if (res.data.isSuccess) {
        //update header totals
        headerService.getHeaderTotals(callback);

        pushEvent('login.successful', '');
      } else {
        pushEvent('login.error', 'bad_credentials');
      }
    }

    return res;
  }

  async logout(callback: Dispatch<UserContextAction> | null): Promise<boolean> {
    const result = await graphQLService.apolloClient.mutate<LogoutMutation, LogoutMutationVariables>({
      mutation: LogoutDocument,
    });

    if (result.data?.logout?.isSuccess) {
      //update header totals & customerContext
      headerService.getHeaderTotals(callback);
    }
    return result.data?.logout?.isSuccess ?? false;
  }
}

export const loginService = new LoginService();
